import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

import Image from 'next/image'
import { FC } from 'react'
import Slider, { CustomArrowProps, Settings } from 'react-slick'

import styles from './CarouselRend.module.scss'

interface ICarouselRenderProps {
  imgList: string[]
}

function CustomNextArrow(props: CustomArrowProps) {
  const { className, style, onClick } = props
  return (
    <div
      className={`${className as string} ${styles.right_arrow}`}
      style={{ ...style }}
      onClick={onClick}>
      <img
        src="/svg/icon_openpath_arrow_right.svg"
        className="hidden lg:inline lg:h-13 lg:w-13 xl:h-18 xl:w-18"
      />
    </div>
  )
}

function CustomPrevArrow(props: CustomArrowProps) {
  const { className, style, onClick } = props
  return (
    <div
      className={`${className as string} ${styles.left_arrow}`}
      style={{ ...style }}
      onClick={onClick}>
      <img
        src="/svg/icon_openpath_arrow_left.svg"
        className="hidden lg:inline lg:h-13 lg:w-13 xl:h-18 xl:w-18"
      />
    </div>
  )
}

const CarouselRender: FC<ICarouselRenderProps> = ({ imgList }) => {
  const settings: Settings = {
    dots: true,
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    touchMove: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    className: 'openPathCarousel',
    // eslint-disable-next-line react/display-name
    appendDots: dots => <ul id={styles.openPathDotContainer}>{dots}</ul>,
    // eslint-disable-next-line react/display-name
    customPaging: () => (
      <div>
        <span id={styles.openPathDot}></span>
      </div>
    ),
  }
  return (
    <Slider {...settings}>
      {imgList.map((url, idx) => (
        <div className={styles.img_container} key={`${url}_${idx}`}>
          <Image src={url} className="h-auto w-full px-12" />
        </div>
      ))}
    </Slider>
  )
}

export default CarouselRender
